import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "company" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "document" }
const _hoisted_10 = {
  key: 0,
  class: "empty"
}
const _hoisted_11 = {
  key: 1,
  class: "empty"
}
const _hoisted_12 = {
  key: 2,
  class: "company-data"
}
const _hoisted_13 = { class: "header" }
const _hoisted_14 = { class: "company" }
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "document" }
const _hoisted_17 = {
  key: 0,
  class: "action"
}
const _hoisted_18 = { class: "addresses" }
const _hoisted_19 = { class: "label border" }
const _hoisted_20 = { class: "checkbox" }
const _hoisted_21 = ["value", "onChange"]
const _hoisted_22 = { class: "infos" }
const _hoisted_23 = { class: "name" }
const _hoisted_24 = { class: "address" }
const _hoisted_25 = { class: "label border" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = {
  key: 0,
  class: "infos"
}
const _hoisted_28 = { class: "name" }
const _hoisted_29 = { class: "address" }
const _hoisted_30 = { class: "contacts" }
const _hoisted_31 = { class: "label border" }
const _hoisted_32 = { class: "checkbox" }
const _hoisted_33 = ["value", "onChange"]
const _hoisted_34 = { class: "infos" }
const _hoisted_35 = { class: "name" }
const _hoisted_36 = { class: "values" }
const _hoisted_37 = { class: "values" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "label border" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = {
  key: 0,
  class: "infos"
}
const _hoisted_42 = { class: "name" }
const _hoisted_43 = { class: "values" }
const _hoisted_44 = { class: "values" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "descriptions" }
const _hoisted_47 = { class: "label border" }
const _hoisted_48 = ["innerHTML"]

import { computed, ref, watch, watchEffect, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import {
  svgIcon,
  baseAvatar,
  baseInput,
  baseConfirm,
} from "@/common/components";

import { addressList } from "@/common/api/rest/address";
import { contactList } from "@/common/api/rest/contact";
import { companyList } from "@/common/api/rest/company";
import {
  evaluationCompanyShow,
  evaluationCompanyCreate,
  evaluationCompanyPatch,
  evaluationCompanyDelete,
} from "@/common/api/rest/evaluation/company";

import type { CompanyListType, CompanyType } from "@/common/types/company";
import type { EvaluationType } from "@/common/types/evaluation";
import type { AddressType, ContactType } from "@/common/types/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'company',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const company = ref<CompanyType | null>(null);
const address = ref<any[]>([]);
const contact = ref<any[]>([]);

const listData = ref<CompanyListType[]>([]);
const selected = ref<CompanyListType | null>(null);
const selectAddress = ref<string | null>(null);
const selectContact = ref<string | null>(null);
const inputSearch = ref("");

const searched = ref(false);
const showAddConfirm = ref(false);
const showDelConfirm = ref(false);

const addressData = computed<AddressType | null>(
  () =>
    address.value.filter(
      (address) => address.address_id === selectAddress.value,
    )[0] ?? null,
);

const contactData = computed<ContactType | null>(
  () =>
    contact.value.filter(
      (address) => address.contact_id === selectContact.value,
    )[0] ?? null,
);

function search() {
  if (!props.data || props.data.company) return;

  searched.value = true;
  companyList(props.data?.account_id, {
    search: inputSearch.value,
    limit: 100,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchAddress() {
  if (!props.data || !props.data.company) return;

  searched.value = true;
  addressList(props.data.account_id, props.data.company.company_id, {
    search: inputSearch.value,
    limit: 100,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        address.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchContact() {
  if (!props.data || !props.data.company) return;

  searched.value = true;

  contactList(props.data.account_id, props.data.company.company_id, {
    search: inputSearch.value,
    limit: 100,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        contact.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchEvaluationCompany() {
  if (!props.data?.company) return;

  evaluationCompanyShow(props.data.account_id, props.data.company.item_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        company.value = props.data.company;
        selectAddress.value = data.address_id;
        selectContact.value = data.contact_id;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function editEvaluationCompany(key: string, value: string) {
  if (!company.value) return;

  const payload = {
    address_id: company.value.address_id,
    contact_id: company.value.contact_id,
    ...{ [key]: value },
  };

  evaluationCompanyPatch(
    props.data.account_id,
    props.data.company.item_id,
    payload,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchEvaluationCompany();
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addCompany() {
  if (!props.data?.account_id || !props.data?.evaluation_id || !selected.value)
    return;

  evaluationCompanyCreate(
    props.data.account_id,
    props.data.evaluation_id,
    selected.value.company_id,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        fetchEvaluationCompany();
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeAddress(id: string) {
  editEvaluationCompany("address_id", id);
}

function changeContact(id: string) {
  editEvaluationCompany("contact_id", id);
}

function add(data: CompanyListType) {
  selected.value = data;
  showAddConfirm.value = true;
}

function addCancel() {
  selected.value = null;
  showAddConfirm.value = false;
}

function addConfirm() {
  if (!props.data) return;

  addCompany();

  searched.value = false;
  inputSearch.value = "";
  addCancel();
}

function del() {
  showDelConfirm.value = true;
}

function delCancel() {
  showDelConfirm.value = false;
}

function delConfirm() {
  if (!props.data || !props.data.company) return;

  evaluationCompanyDelete(props.data.account_id, props.data.company.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        company.value = null;
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });

  delCancel();
}

function update() {
  emit("update-data");
}

onMounted(() => {
  fetchEvaluationCompany();
  fetchAddress();
  fetchContact();
  search();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.company")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!__props.data?.company && __props.isEdit)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(baseInput), {
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
                background: "#fff",
                color: "#000",
                placeholder: _unref(t)('common.labels.search'),
                disabled: !!__props.data?.company?.company_id
              }, {
                sufix: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(svgIcon), {
                      icon: "search",
                      size: "1.75rem",
                      onClick: search
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "disabled"])
            ]),
            (searched.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "item",
                      onClick: ($event: any) => (add(item))
                    }, [
                      _createVNode(_unref(baseAvatar), {
                        url: item?.avatar?.small,
                        size: "1.5rem"
                      }, null, 8, ["url"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.document_name) + " - " + _toDisplayString(item.document_number), 1)
                      ])
                    ], 8, _hoisted_6))
                  }), 128)),
                  (listData.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (!__props.data?.company && !__props.isEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
        : _createCommentVNode("", true),
      (company.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(baseAvatar), {
                url: company.value?.avatar?.small,
                size: "3rem"
              }, null, 8, ["url"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(company.value.name), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(company.value.document_name) + " - " + _toDisplayString(company.value.document_number), 1)
              ]),
              (__props.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-none btn-sm remove",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (del()))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "trash",
                        size: "1.75rem"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (__props.isEdit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("common.labels.addresses").toUpperCase()), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(address.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item"
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectAddress).value = $event)),
                            value: item.address_id,
                            onChange: ($event: any) => (changeAddress(item.address_id))
                          }, null, 40, _hoisted_21), [
                            [_vModelRadio, selectAddress.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.address) + " - " + _toDisplayString(item.district) + " - " + _toDisplayString(item.city) + " - " + _toDisplayString(item.state) + " - " + _toDisplayString(item.country) + " - " + _toDisplayString(item.cep), 1)
                        ])
                      ]))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("common.labels.address").toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (addressData.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(addressData.value.name), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(addressData.value.address) + " - " + _toDisplayString(addressData.value.district) + " - " + _toDisplayString(addressData.value.city) + " - " + _toDisplayString(addressData.value.state) + " - " + _toDisplayString(addressData.value.country) + " - " + _toDisplayString(addressData.value.cep), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_30, [
              (__props.isEdit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("common.labels.contacts").toUpperCase()), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item"
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectContact).value = $event)),
                            value: item.contact_id,
                            onChange: ($event: any) => (changeContact(item.contact_id))
                          }, null, 40, _hoisted_33), [
                            [_vModelRadio, selectContact.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)(`common.labels.${item.type}`)) + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(item.contact), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)(`common.labels.description`)) + ": ", 1),
                            _createElementVNode("span", {
                              innerHTML: item.description
                            }, null, 8, _hoisted_38)
                          ])
                        ])
                      ]))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("common.labels.contact").toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (contactData.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, _toDisplayString(contactData.value.name), 1),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("label", null, _toDisplayString(_unref(t)(`common.labels.${contactData.value.type}`)) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(contactData.value.contact), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("label", null, _toDisplayString(_unref(t)(`common.labels.description`)) + ": ", 1),
                              _createElementVNode("span", {
                                innerHTML: contactData.value.description
                              }, null, 8, _hoisted_45)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)("common.labels.description").toUpperCase()), 1)
              ]),
              _createElementVNode("div", {
                class: "value",
                innerHTML: company.value.description
              }, null, 8, _hoisted_48)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showAddConfirm.value,
      "max-width": "500px",
      title: _unref(t)('evaluation.modal.titles.add_company').toUpperCase(),
      message: 
        _unref(t)('evaluation.modal.messages.add_company', {
          concat: selected.value?.name,
        })
      ,
      onCancel: addCancel,
      onConfirm: addConfirm
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "500px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.company'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: _unref(t)('common.labels.company'),
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})